import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import _ from "lodash"
import { Asterisk, Check, Globe, User, CircleUser } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { GridTableButton, Menubar, Tabset, TagsManager } from "lib/components"
import { Forms } from "lib/components/forms"

const processingOpts = [
  { value: "html+css", label: "Send the html + css to the Midmetrics server." },
  { value: "generate+noedit", label: "Generate the PDF here, but do not engage any of the editing modules." },
  { value: "generate+edit", label: "Generate the PDF here, and engage any editing modules that have been selected." }
]

export default function ClientSetup(){
  const { cid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { data:_Client } = queryTools.resource.parseQueryForApi("client.findById", { _id: cid })
  const saveMethod = queryTools.resource.save(["client.all"])

  const [ clientFormData, setClientFormData ] = useState<any>()

  const setProcessorOption = (value:string) => {
    setClientFormData((prev:any) => ({
        ...prev, configs: {...prev.configs, processing: value }
      })
    )
  }

  const handleInputChange = (e:any) => setClientFormData({ ...clientFormData, [e.target.name]: e.target.value })

  const saveClient = (e:any) => {
    e.preventDefault()
    const dataToSave = { ...clientFormData, configs: { ...clientFormData.configs, processing: clientFormData.configs.processing } }
    const resp = saveMethod.mutate({ resource: "client", data: dataToSave } )
    console.log(resp)
  }

  useEffect(() => {
    if( cid && cid !== "0" && _Client ){
      setClientFormData(_Client)
    }
  },[cid, _Client])
  
  if( !_Client || !clientFormData ) return <></>
  return (
  <div className="w-full flex flex-col pt-4">
    <h3 className="w-full text-lg uppercase pb-1 pl-2 mb-4 border-b border-solid border-slate-700">Client Setup</h3>
    <div className="w-full flex gap-10">
      
      <div className="w-6/12 flex flex-col">
        <Forms.Form className="w-full flex flex-col">
          <Forms.FieldGroup label="Client Name" className="w-full">
            <Forms.InputField 
              type="text" 
              name="name" 
              value={clientFormData.name} 
              onChange={handleInputChange}  
            />
          </Forms.FieldGroup>

          <Forms.FieldGroup label="Subdomain" className="w-full">
            <Forms.InputField 
              type="text" 
              name="subdomain" 
              value={clientFormData.subdomain} 
              onChange={handleInputChange}  
            />
          </Forms.FieldGroup>

          <Forms.FieldGroup label="Description" className="w-full">
            <Forms.Textarea 
              name="description" 
              value={clientFormData.description} 
              onChange={handleInputChange}  
            />
          </Forms.FieldGroup>

          <Forms.FieldGroup className="mt-3 w-full flex flex-row justify-end">
            <button 
              onClick={saveClient}
              className="relative m-0 w-5/12 border border-solid border-teal-800 rounded h-10 px-4 bg-teal-900"
            >
              Save Changes
            </button>
          </Forms.FieldGroup>

        </Forms.Form>
      </div>

      <div className="w-6/12 flex flex-col">
        <h3 className="text-base uppercase pb-1 mb-3 border-b border-solid border-slate-700">Processing</h3>
        <p className="text-sm">When a request is received for this template, how should it be processed:</p>

        <div className="w-full flex flex-col gap-8 mt-4">

          { processingOpts.map( (opt:any) => (
            <div key={opt.value} className="w-full relative ">
              <div 
                onClick={() => setProcessorOption(opt.value)}
                className="absolute top-0 left-0 w-[2rem] h-[2rem] bg-transparent border border-solid border-slate-700 flex justify-center items-center cursor-pointer"
              >
                <Check 
                    className={cn(
                      "text-green-500 w-6 h-6 stroke-1 cursor-pointer",
                      clientFormData?.configs?.processing !== opt.value && "hidden"
                    )} />
              </div>
              {/* <input type="checkbox" name="IsActive" defaultChecked={_Template.IsActive} className="w-5 h-5" /> */}
              <div className="relative ml-12 h-[2rem]">
                <label className="text-sm">{opt.label}</label>
              </div>
            </div>
          ))}

        </div>
      </div>
    </div>
    </div> 
  )
}